/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from 'linced-app/models/person';
import type School from 'linced-app/models/school';

// Proto: attendance.Threshold.
export default class Threshold extends Model {
  declare [Type]: 'attendance/threshold';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @attr('string')
  declare date: string | undefined;

  @attr('number', { defaultValue: 0 })
  declare threshold: number;
}
